import React from "react";
import { LanguageContext } from "../common/language";
import FileImportButton from "../components/FileImportButton";
import ListPage from "../components/pages/ListPage";
import { useSeasons } from "../data/useSeasons";
import { RootTabScreenProps } from "../types";
import { CollectionListSpec } from "../components/CollectionList";
import { episodeNumberLabel, formatTimestamp } from "../common/util";
import { useNavigation } from "@react-navigation/native";
import ListItem from "../components/ListItem";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { compareEpisodes, Episode, toEpisode } from "@atgof-common/episode";
import { EpisodeInfo } from "../components/EpisodeInfo";
import { useProject } from "../data/useProject";
import { useDocument } from "../data/useDocument";

export default function EpisodesScreen({}: RootTabScreenProps<"episodes">) {
  const { ph } = React.useContext(LanguageContext);
  const daysRatherThanEpisodes: boolean =
    useDocument(useProject())?.get("daysRatherThanEpisodes") ?? false;
  const navigation = useNavigation();
  const renderItem = React.useCallback(
    ({ item }: { item: Episode }) => {
      const { path } = item;
      return (
        <ListItem
          onPress={() => navigation.navigate("episode", { episodePath: path })}
        >
          <View
            style={{
              flexDirection: "row",
              alignContent: "flex-start",
              overflow: "hidden",
            }}
          >
            <View style={{}}>
              <Text variant="headlineLarge" style={{ marginRight: 20 }}>
                {episodeNumberLabel(path)}
              </Text>
            </View>
            <EpisodeInfo episode={item} />
          </View>
        </ListItem>
      );
    },
    [ph, navigation],
  );
  const seasons = useSeasons(true);
  const [collections, setCollections] =
    React.useState<CollectionListSpec<Episode, string>[]>();
  React.useEffect(
    () =>
      setCollections(
        seasons?.map((season) => ({
          collection: season.ref.collection("episodes"),
          process: (docs) =>
            daysRatherThanEpisodes
              ? docs.sort(compareEpisodes).map(toEpisode)
              : docs.sort(compareEpisodes).reverse().map(toEpisode),
          renderItem,
          searchTokens: (item) => [
            item.director,
            formatTimestamp(item.txDate),
            ...item.path.split("/").reverse().slice(0, 2), // TODO This should be properly generalised
          ],
          ...(daysRatherThanEpisodes
            ? {}
            : {
                headerData: ph("season") + " " + season.id,
                renderHeader: (title) => (
                  <Text variant="headlineLarge">{title}</Text>
                ),
              }),
        })),
      ),
    [seasons, ph, daysRatherThanEpisodes],
  );
  return (
    <ListPage
      headerRight={<FileImportButton />}
      collections={collections}
      estimatedItemSize={52}
    />
  );
}
